/**
 * @author Matthew Rogers.
 * Section for FTP to GPP results
 */
var ftpgppBind = { vm: '=' };
var FTPGPPDetailsController = (function () {
    function FTPGPPDetailsController(topic, $filter, settings) {
        this.topic = topic;
        this.$filter = $filter;
        this.settings = settings;
    }
    FTPGPPDetailsController.prototype.$onInit = function () {
        this.gppftpDetails = 'This Disbursement has been checked for GPP Status Update.  The results are as follows:\n\n' +
            'Date Checked: ' + this.$filter('date')(new Date(this.topic.topic.ftp_gppreport.date_processed), this.settings.up.preferences.dateFormat) +
            '\nData Sent back to GPP: ' + this.topic.topic.ftp_gppreport.data_sent +
            '\n\nIf nothing sent it means there must be other open Disbursements for this Opportunity';
    };
    FTPGPPDetailsController.$inject = ['topic', '$filter', 'settings'];
    return FTPGPPDetailsController;
}());
var FTPGPPDetailsComponent = (function () {
    function FTPGPPDetailsComponent() {
        this.bindings = ftpgppBind;
        this.templateUrl = 'ftpgpp-details.html';
        this.controller = FTPGPPDetailsController;
    }
    return FTPGPPDetailsComponent;
}());
angular
    .module('application')
    .component('ftpgppDetailsSection', new FTPGPPDetailsComponent());

//# sourceMappingURL=gppftp.details.component.js.map
